import { render, staticRenderFns } from "./EmailVerificationSuccess.vue?vue&type=template&id=c8de1354&scoped=true&"
import script from "./EmailVerificationSuccess.vue?vue&type=script&lang=js&"
export * from "./EmailVerificationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerificationSuccess.vue?vue&type=style&index=0&id=c8de1354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8de1354",
  null
  
)

export default component.exports